import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from '../ui/CTAButton';
import { TrustBadges } from '../ui/TrustBadges';
import { FileText, Zap, Home, Dumbbell } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center justify-center pt-12 pb-20 px-4 overflow-hidden" data-id="element-107">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-108">
        <div className="absolute inset-0 bg-hero-pattern z-10" data-id="element-109" />
        <img src="https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?w=1600&q=70&auto=format&fit=crop" alt="Persona entrenando en casa" loading="eager" decoding="async" fetchPriority="high" className="w-full h-full object-cover opacity-40" data-id="element-110" />
      </div>

      <div className="relative z-20 max-w-4xl mx-auto text-center" data-id="element-111">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-112">
          <h2 className="text-brand font-bold tracking-widest uppercase mb-4 text-sm md:text-base" data-id="element-113">
            Entrena en Casa™ Megapack
          </h2>

          <div className="flex items-center justify-center gap-4 mb-6" data-id="element-114">
            <span className="text-6xl md:text-8xl font-display text-white text-glow" data-id="element-115">
              6
            </span>
            <span className="text-4xl md:text-6xl font-display text-gray-500" data-id="element-116">
              +
            </span>
            <span className="text-6xl md:text-8xl font-display text-brand text-glow" data-id="element-117">
              3
            </span>
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-display uppercase leading-[0.9] mb-6" data-id="element-118">
            Tomos <span className="text-brand" data-id="element-119">+</span> Bonus
          </h1>

          <p className="text-lg md:text-xl text-gray-300 max-w-2xl mx-auto mb-8 font-medium leading-relaxed" data-id="element-120">
            Tu sistema completo para transformar tu cuerpo desde casa: rutinas,
            hábitos, motivación, alimentación y disciplina. Sin gimnasio. Sin
            presión. Sin volver a abandonar.
          </p>

          <div className="flex flex-wrap justify-center gap-4 mb-10" data-id="element-121">
            {[{
            icon: FileText,
            text: 'PDF Digital'
          }, {
            icon: Zap,
            text: 'Acceso Inmediato'
          }, {
            icon: Home,
            text: 'Entrena Desde Casa'
          }, {
            icon: Dumbbell,
            text: 'Principiante - Intermedio'
          }].map((feature, i) => <div key={i} className="flex items-center gap-2 bg-dark-card/80 backdrop-blur border border-dark-border px-4 py-2 rounded-full text-sm font-medium text-gray-200" data-id="element-122">
                <feature.icon className="w-4 h-4 text-brand" data-id="element-123" />
                {feature.text}
              </div>)}
          </div>

          <div className="flex flex-col items-center gap-6" data-id="element-124">
            <CTAButton className="w-full md:w-auto md:px-12 md:py-6 text-2xl md:text-3xl" data-id="element-125">
              QUIERO TRANSFORMAR MI CUERPO AHORA
            </CTAButton>

            <TrustBadges data-id="element-126" />
          </div>
        </motion.div>
      </div>
    </section>;
}